import { InputHTMLAttributes, ReactNode, forwardRef } from 'react';

import { cn } from '@/lib/cn';

type SearchInputProps = {
    onChangeValue: (value: string) => void;
    className?: string;
    icon: ReactNode;
} & InputHTMLAttributes<HTMLInputElement>;

export const SearchInputWithIcon = forwardRef<
    HTMLInputElement,
    SearchInputProps
>(({ onChangeValue, className, icon, ...rest }: SearchInputProps, ref) => (
    <div className={cn('relative', className)}>
        <div className="absolute top-1/2 right-0 translate-y-[-50%] pr-4">
            {icon}
        </div>
        <input
            className={cn(
                'form-control focus:border-action! rounded-lg border border-(--color-border-default) p-4 pr-12 placeholder:text-(--color-text-secondary) placeholder:opacity-100 read-only:bg-white focus:border-2',
                className,
            )}
            ref={ref}
            type="text"
            onChange={({ currentTarget }) => {
                const { value } = currentTarget;
                onChangeValue(value);
            }}
            {...rest}
            autoComplete="off"
        />
    </div>
));
